<div data-index="2" [ngClass]="{'d-none':inProgress===true}">
    <div class="file-img-preview-wrap"><img src="{{path}}" class="file-img-preview"> </div>
    <div class="file-name-wrap like-pseudo-btn"><span class="file-name">{{fileName}}</span><button (click)="onClickRemoveButton($event)"
            class="remove-file btn btn-sm" type="button" title="Eliminar"><i
                class="pj-ico pj-ico-modal-error my-icon"></i> </button> </div>
</div>


<div data-index="2" [ngClass]="{'d-none':inProgress===false}">
    <div style="border: 1px solid #ededed; min-width: 68px;">
        <div class="form-control progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
            attr.aria-valuenow="{{progressPercentaje}}" aria-valuemin="0" aria-valuemax="100"
            [ngStyle]="{width:progressPercentaje+'%'}">
            {{progressPercentaje}}%</div>
    </div>
</div>